'use strict';

/**
 * Crear nueva Asignación de empleado
 */
angular.module('thothApp.controllers')
  .controller('AssignmentsNewCtrl', [
    '$scope', '$state', '$q', 'Assignment', 'Employee', 'Client', 'ProductCatalog', 'toaster', '$stateParams',
    function ($scope, $state, $q, Assignment, Employee, Client, ProductCatalog, toaster, $stateParams) {
      $scope.form = {
        employee_id: null,
        client_id: null,
        product_catalog_id: null,
        start_on: null,
        end_on: null 
      };
      $scope.selectedEmployee = null;
      $scope.searchEmployee = '';
      $scope.errors = [];
      $scope.saving = false;
      $scope.selectedClient = null;
      $scope.searchClient = '';
      $scope.productOptions = [];
      $scope.selectedProductId = null;
      $scope.isEdit = !!$stateParams.assignmentId;
      $scope.startLocked = false;
      $scope.endLocked = false;

      function toInt(v){ var n = parseInt(v,10); return isNaN(n)? null : n; }
      function parseYmd(s){
        if (!s) return null;
        if (angular.isDate(s)) return s;
        if (!angular.isString(s)) return null;
        var m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!m) { try { return new Date(s); } catch(e){ return null; } }
        return new Date(parseInt(m[1],10), parseInt(m[2],10)-1, parseInt(m[3],10));
      }
      function normalizeProducts(arr){
        if (!angular.isArray(arr)) return [];
        return arr.map(function(p){
          return {
            product_catalog_id: (p.product_catalog_id != null ? toInt(p.product_catalog_id) : toInt(p.id)),
            product_catalog_name: p.product_catalog_name || p.name || p.product_name
          };
        }).filter(function(p){ return p.product_catalog_id != null; });
      }
      function loadProductsForClient(clientId){
        if (!clientId) { $scope.productOptions = []; return $q.when([]); }
        return Client.find(clientId).then(function(resp){
          var c = (resp.data && (resp.data.client || resp.data)) || {};
          $scope.productOptions = normalizeProducts(c.client_product_catalogs || []);
          return $scope.productOptions;
        }).catch(function(){ $scope.productOptions = []; return []; });
      }

      if($stateParams.assignmentId) {
        Assignment.find($stateParams.assignmentId).then(function(response) {
          var a = response.data && (response.data.assignment || response.data) || {};
          $scope.form.employee_id = toInt(a.employee_id);
          $scope.form.client_id = toInt(a.client_id);
          $scope.form.product_catalog_id = toInt(a.product_catalog_id);
          $scope.form.start_on = parseYmd(a.start_on);
          $scope.form.end_on   = parseYmd(a.end_on);

          (function(){
            var today = new Date();
            today.setHours(0,0,0,0);
            var s = new Date($scope.form.start_on);
            var e = new Date($scope.form.end_on);
            if (s && !isNaN(s.getTime())) {
              s.setHours(0,0,0,0);
              $scope.startLocked = s <= today;
            }
            if (e && !isNaN(e.getTime())) {
              e.setHours(0,0,0,0);
              $scope.endLocked = e <= today;
            }
          })();

          if (a.employee_name || a.employee_full_name) {
            $scope.selectedEmployee = { id: $scope.form.employee_id, name: a.employee_name || a.employee_full_name };
          }

          if (a.client_name) {
            $scope.selectedClient = { id: $scope.form.client_id, name: a.client_name };
          }

          loadProductsForClient($scope.form.client_id).then(function(){
            $scope.form.product_catalog_id = toInt(a.product_catalog_id);
            var found = ($scope.productOptions || []).some(function(p){ return p.product_catalog_id === $scope.form.product_catalog_id; });
            if (!found && $scope.form.product_catalog_id) {
              var pname = a.product_name || a.product_catalog_name || ('#' + $scope.form.product_catalog_id);
              $scope.productOptions = ($scope.productOptions || []).concat([{ product_catalog_id: $scope.form.product_catalog_id, product_catalog_name: pname }]);
            }
          });
        }, function(error) {
          Assignment.error(error);
        });
      } else {
        resetForm();
      }

      function asMessages(errs){
        if (!errs) return ['Ocurrió un error'];
        if (angular.isString(errs)) return [errs];
        var out = [];
        if (angular.isArray(errs)) {
          return errs.map(function(e){ return angular.isString(e) ? e : JSON.stringify(e); });
        }
        angular.forEach(errs, function(val, key){
          if (angular.isArray(val)) {
            val.forEach(function(m){ out.push(m); });
          } else if (angular.isObject(val)) {
            if (val.full_messages && angular.isArray(val.full_messages)) {
              val.full_messages.forEach(function(m){ out.push(m); });
            } else {
              out.push(JSON.stringify(val));
            }
          } else if (val) {
            out.push(String(val));
          }
        });
        return out.length ? out : ['Error desconocido'];
      }

      $scope.employeeSearch = function(searchQuery){
        if (!searchQuery) { return []; }
        var params = { params: { search: searchQuery, assignable: true, per_page: 10 } };
        var deferred = $q.defer();
        Employee.index(params).then(function(resp){
          var list = (resp.data && (resp.data.employees || resp.data)) || [];
          deferred.resolve(list);
        }).catch(function(err){
          deferred.reject(err);
        });
        return deferred.promise;
      };

      $scope.selectedEmployeeChange = function(emp){
        $scope.form.employee_id = emp && emp.id ? emp.id : null;
      };

      $scope.clientSearch = function(searchQuery){
        if (!searchQuery) {
          return [];
        }
        var customerParams = {
          'params': {
            'search': searchQuery,
            'with_products': true
          }
        };
        var deferred = $q.defer();
        Client.index(customerParams).then((response) => {
          var list = (response.data && (response.data.clients || response.data)) || [];
          deferred.resolve(list);
        }).catch((error) => {
          Client.error(error);
          deferred.reject(error);
        });
        return deferred.promise;
      };

      $scope.selectedClientChange = function(client){
        $scope.form.client_id = client && client.id ? client.id : null;
        $scope.productOptions = [];
        $scope.selectedProductId = null;
        $scope.form.product_catalog_id = null;
        if ($scope.form.client_id) {
          if (client && client.client_product_catalogs && client.client_product_catalogs.length) {
            $scope.productOptions = normalizeProducts(client.client_product_catalogs);
          } else {
            loadProductsForClient($scope.form.client_id);
          }
        }
      };

      $scope.onSelectProduct = function(){
        $scope.form.product_catalog_id = $scope.selectedProductId || null;
      };

      function fmt(date){
        if (!date) return null;
        if (angular.isString(date)) return date;
        var d = new Date(date);
        var y = d.getFullYear();
        var m = ('0' + (d.getMonth()+1)).slice(-2);
        var dd = ('0' + d.getDate()).slice(-2);
        return y + '-' + m + '-' + dd;
      }

      function resetForm(){
        $scope.form = {
          employee_id: null,
          client_id: null,
          product_catalog_id: null,
          start_on: null,
          end_on: null
        };
        $scope.startLocked = false;
        $scope.endLocked = false;
        $scope.selectedEmployee = null;
        $scope.selectedClient = null;
        $scope.searchEmployee = '';
        $scope.searchClient = '';
        $scope.productOptions = [];
        $scope.selectedProductId = null;
        $scope.errors = [];
        if ($scope.assignmentForm && $scope.assignmentForm.$setPristine) {
          $scope.assignmentForm.$setPristine();
          $scope.assignmentForm.$setUntouched();
        }
      }

      $scope.save = function(){
        $scope.errors = [];
        $scope.saving = true;

        var startOnFmt = fmt($scope.form.start_on);
        var endOnFmt   = fmt($scope.form.end_on);

        var payload = { assignment: {
          employee_id: $scope.form.employee_id,
          client_id: $scope.form.client_id,
          product_catalog_id: $scope.form.product_catalog_id,
          end_on: endOnFmt
        }};
        if (!($scope.isEdit && $scope.startLocked)) {
          payload.assignment.start_on = startOnFmt;
        }

        var promise = $scope.isEdit ? Assignment.update($stateParams.assignmentId, payload)
                                    : Assignment.create(payload);
        promise
          .then(function(){
            if ($scope.isEdit) {
              $state.go('app.assignments.list');
              toaster.pop('success', 'Asignación', 'Asignación actualizada correctamente');
            } else {
              resetForm();
              toaster.pop('success', 'Asignación', 'Asignación creada correctamente');
            }
            $state.go('app.assignments.list');
          })
          .catch(function(err){
            var data = (err && err.data) || {};
            var messages = asMessages(data.errors || data);
            $scope.errors = messages;
            toaster.pop('error', 'Asignación', messages.join('\n'));
          })
          .finally(function(){
            $scope.saving = false;
          });
      };

      $scope.cancel = function(){
        $state.go('app.assignments.list');
      };
    }
  ]);
